import { Component, OnInit } from "@angular/core";
import {
    EmitEvent,
    EventBusService,
} from "../../core/services/event-bus.service";
import { NbcLoggerService } from "../../shared/logger/nbc-logger.service";
import { TimesheetService } from "../../shared/services/timesheet.service";
import { SharedDataService } from "../../shared/sharedData.service";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

@Component({
    selector: "fin-pay-dept",
    templateUrl: "./fin-pay-dept.component.html",
    standalone: false
})
export class FinPayrollDeptComponent implements OnInit {
    constructor(
        private _eventBus: EventBusService,
        private timesheetService: TimesheetService,
        private _sharedService: SharedDataService,
        private router: Router,
        private log: NbcLoggerService
    ) {}

    selectedBusinessUnit: any;
    dashboardData: any = [];
    searchButtonDisable: any = false;
    queryContainer: any;

    getQueryContainer() {
        const query = this.timesheetService.getTimesheetSummaryQuery();
        return {
            query: query,
        };
    }

    search() {
        this.getTimecardSummary();
    }

    reset() {
        this.queryContainer.query.searchTerm.description = "";
        this.getTimecardSummary();
    }

    openRunningTimecard() {
        this.log.trace("Open running list");
        // $window.location.href = "/TalentPayroll/Dashboard/TalentPayrollTimesheet/" + this.selectedBusinessUnit.id;
        this.router.navigate(["/bu/" + this.selectedBusinessUnit.id]);
    }

    getTimecardSummary() {
        this.dashboardData = null;
        this.log.trace("Get Timecard Summary");
        this.queryContainer.query.businessUnitId = this.selectedBusinessUnit.id;
        this.queryContainer.query.timesheetStatus = "InProgress";

        this.timesheetService
            .getTimeCardSummary(this.queryContainer.query)
            .subscribe({
                next: (result) => {
                    this.dashboardData = result;
                },
                error: (err) => {
                    this.log.error("got an error: " + JSON.stringify(err));
                    this.log.showError(
                        "Unable to load the timecard Summary at this time. Please try again later."
                    );
                },
            });
    }

    subscribeEventHandlers() {
        this._sharedService
            .getSelectedBusinessUnit()
            .subscribe(
                (selectedBu) => (this.selectedBusinessUnit = selectedBu)
            );
    }

    ngOnInit() {
        this.subscribeEventHandlers();
        this.queryContainer = this.getQueryContainer();
        this.getTimecardSummary();
    }
}
